import { Location } from '@app/shared/routes';

const BaleaApplicationsLocation = new Location({
  path: '/balea/users'
});

export { BaleaApplicationsLocation };
